import React from 'react';

import { SvgIcon } from 'components/elems';
import { cx } from 'helpers';


const CloseButton = ({ onClick, className }) => (
  <span
    className={cx(
      'absolute flex pointer z-1 black',
      className
    )}
    style={{ top: '12px', right: '8px' }}
    onClick={onClick}
  >
    <SvgIcon.md.Close />
  </span>
);


class Alert extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isVisible: true };

    this.dismiss = this.dismiss.bind(this);
  }

  componentDidMount() {
    const {
      alertTimeout = 3000,
      micronAnim = null,
    } = this.props;

    if (alertTimeout > 0) {
      setTimeout(this.dismiss, alertTimeout);
    }

    if (micronAnim) {
      // setTimeout set at 0, otherwise react swallows the animation?
      setTimeout(() => {
        this.alert.classList.add(`mjs-${micronAnim}`);
      }, 0);
    }
  }

  dismiss() {
    if (this.state.isVisible) {
      this.setState({isVisible: false});
    }
  }

  render() {
    if (!this.state.isVisible) {
      return null;
    }

    const {
      children,
      withCloseButton = true,
      className,
      style = {},
    } = this.props;

    return (
      <div
        ref={ref => this.alert = ref}
        style={{
          animationDuration: '0.5s',
          ...style,
        }}
        className={cx('relative mb2', className)}
      >
        {withCloseButton && (
          <CloseButton
            className="absolute"
            onClick={this.dismiss}
          />
        )}

        {children}
      </div>
    );
  }
}


export default Alert;



// WEBPACK FOOTER //
// ./src/components/elems/Alert.js